import { render } from "./ApplicationSuccessMessage.vue?vue&type=template&id=cbfb3fd4&scoped=true"
import script from "./ApplicationSuccessMessage.vue?vue&type=script&lang=js"
export * from "./ApplicationSuccessMessage.vue?vue&type=script&lang=js"

import "./ApplicationSuccessMessage.vue?vue&type=style&index=0&id=cbfb3fd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbfb3fd4"]])

export default __exports__